<template>
    <div class="animated fadeIn">
    
        <ChangeControlUnitComponent v-if="!$store.state.currentUnit.id" />
        <ChangeControlHeaderComponent v-if="$store.state.currentUnit.id" />

        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                <b-card header="DENOMINAÇÕES">
                    <b-row>
                        <b-col sm="5">
                            <h4 id="traffic" class="card-title mb-0"></h4>
                            <div class="small text-muted">&nbsp;</div>
                            <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                <b-button type="button" @click="getDenominations()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                                <span style="width:10px"></span>
                                <b-button type="button" @click="$bvModal.show('help')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
                            </b-button-toolbar>
                            
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12">
                            <b-row>
                                <b-col sm="6" md="4" lg="3" xl="2"  v-for="item in data_denomination" :key="item.id">
                                    <Callout :variant="item.variant">
                                      <center>
                                        <strong class="h6 text-muted">R$ {{ numberFormat(item.value) }}</strong><br>
                                        <small class="text-muted"><img :src="item.image" width="80px" :style="{ width: item.imageWidth +'px' }"></small>
                                        <br>&nbsp;
                                        <br>
                                        <b-form-group>
                                            <b-form-input type="text" :id="item.varname" :name="item.varname" v-model="item.quantity" v-on:keyup="changeQuantity" placeholder="" v-on:keypress="numbersOnly" style="width: 105px"> </b-form-input>  <small class="text-muted"> / {{ item.totalQuantity }}</small>
                                        </b-form-group>
                                        <small class="text-muted">R$ </small><strong class="h5">{{ numberFormat(item.quantity * item.value) }}</strong><br>
                                      </center>
                                    </Callout>
                                </b-col>
                            </b-row>
                            
                        </b-col>
                    </b-row>



                    <div slot="footer">
                        <b-row class="text-center">
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">Total em Moedas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(total_coin) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="total_coin * 100 / total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0 d-md-down-none">
                            <div class="text-muted">Total em Cédulas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(total_note) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="total_note * 100 / total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">TOTAL</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(total) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="total * 100 / total"></b-progress>
                        </b-col>        
                        </b-row>
                    </div>

                       
                    <b-row>
                       
                                <b-col sm="6" md="4" lg="4">
                                    <Callout variant="primary">
                                        <strong class="h4">AUTORIZAÇÃO SUPERVISOR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="supervisor_code" placeholder="" v-model="selectedSupervisor.name" readonly></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="text" id="supervisor_name" placeholder="USUÁRIO SUPERVISOR" v-model="selectedSupervisor.code" @blur="getSupervisor()"></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="password" id="supervisor_password" placeholder="SENHA" v-model="selectedSupervisor.password"></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>

                                 <b-col sm="6" md="4" lg="4">
                                    <Callout variant="danger">
                                        <strong class="h4">CONFIRMAÇÃO OPERADOR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="operator_code" placeholder="" v-model="selectedOperator.name" readonly></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="text" id="operator_name" placeholder="USUÁRIO OPERADOR" v-model="selectedOperator.code" @blur="getOperator()"></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group>
                                            <b-form-input type="password" id="operator_password" placeholder="SENHA" v-model="selectedOperator.password" ></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>


                                <b-col sm="6" md="4" lg="4">
                                    <Callout variant="success">
                                        <strong class="h4">TOTAL</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="total" placeholder="" :value="numberFormat(total)" readonly></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="5">
                        <h4 id="traffic" class="card-title mb-0">&nbsp;</h4>
                        <div class="small text-muted">&nbsp;</div>
                        <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                        <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                            <b-button type="button" @click="templateSave()" variant="success" class="float-right">Salvar Como Modelo</b-button>
                            <span style="width: 10px"></span>
                            <b-button type="button" @click="confirmWithdraw()" variant="danger" class="float-right">Confirmar Retirada</b-button>

                           
                        </b-button-toolbar>
                        
                        </b-col>
                    </b-row>

                    
                </b-card>
    
               

            </b-col>
        </b-row>


        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                 <b-card header="MODELOS DE RETIRADA / PACOTE">
                    <b-row>
                        <b-col sm="5">
                            <h4 id="traffic" class="card-title mb-0"></h4>
                            <div class="small text-muted">&nbsp;</div>
                            <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                <b-button type="button" @click="getTemplate()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                                <span style="width:10px"></span>
                                <b-button type="button" @click="$bvModal.show('help-template')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
                            </b-button-toolbar>
                            
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6" md="4" lg="3" v-for="item in data_change_template" :key="item.id">
                            <b-card no-body class="bg-success" :class="[ item.class && item.class != null && item.class != '' ? item.class : 'bg-primary' ]">
                                <b-card-body class="pb-0">
                                    <b-dropdown class="float-right" variant="transparent p-0" right>
                                        <template slot="button-content">
                                        <i class="icon-settings"></i>
                                        </template>
                                        <b-dropdown-item @click="templateSelect(item)">Selecionar modelo</b-dropdown-item>
                                        <b-dropdown-divider></b-dropdown-divider>
                                        <b-dropdown-item @click="$bvModal.show('modal-template'); selectedTemplate=Object.assign({},item);">Alterar nome do modelo</b-dropdown-item>
                                        <b-dropdown-item @click="messageConfirmDelete(item)">Excluir</b-dropdown-item>
                                    </b-dropdown>
                                    <p>{{ item.createDate }}
                                        <h5 class="mb-0">{{ item.name }}</h5>
                                        <h4 class="mb-0"><small>R$ </small> {{ numberFormat(item.total) }}</h4>
                                    </p>
                                </b-card-body>
                            </b-card>
                        </b-col>
                    </b-row>

                    <div slot="footer">
                    <b-row class="text-center">
                    </b-row>
                    </div>
                </b-card>

                
            </b-col>
        </b-row>


        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                <b-card header="ÚLTIMAS RETIRADAS">
                    <b-row>
                        <b-col sm="5">
                            <h4 id="traffic" class="card-title mb-0"></h4>
                            <div class="small text-muted">&nbsp;</div>
                            <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                <b-button type="button" @click="getWaitingReturn()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                                <span style="width:10px"></span>
                                <b-button type="button" @click="$bvModal.show('help-template')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
                            </b-button-toolbar>
                            
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="6" lg="3" v-for="item in data_change_outgoing" :key="item.id">
                        <ChangeControlItemComponent :controlitem="item" :controltype="1" />
                        </b-col>
                    </b-row>

                    <div slot="footer">
                    <b-row class="text-center">
                    </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <div>
            <b-modal
            id="modal-template"
            ref="modal"
            title="Modelo"
            @show="templateReset"
            @hidden="templateReset"
            @ok="templateHandleOk"
            ok-title="OK"
            cancel-title="Cancelar"
            >
            <form ref="form" @submit.stop.prevent="templateHandleSubmit">
                <b-form-group
                label="Nome do modelo"
                label-for="name-input"
                TODO_invalid-feedback="Nome obrigatório com no mínimo 3 caracteres. Verifique se já existe um modelo com o mesmo nome."
                :state="templateState"
                >
                <b-form-input
                    id="name-input"
                    v-model="selectedTemplate.name"
                    :state="templateState"
                    required
                ></b-form-input>
                <div class="invalid-feedback">
                    {{ selectedTemplate.message  }}
                </div>
                </b-form-group>
            </form>
            </b-modal>
        </div>


        <div>
        <b-modal id="help" title="Ajuda" ok-only size="lg"
        ok-title="Fechar">
            <h3>Controle de Troco - Retirada / Saída de Gaveta</h3>
            <h4>Denominações</h4>
            <p class="my-4">
            <ol>
                <li>Selecione a quantidade de denominações (moedas e cédulas) a serem entregues.<br><span class="small text-muted">Obs: Os totalizadores serão exibidos.</span></li>
                <li>Caso a quantidade de denominações selecionada seja sempre utilizada, é possível gravá-la como um <i>Modelo de Retirada / Pacote</i>. Clique em <i>Salvar Como Modelo</i> e entre com um nome. Para utilizar o modelo, clique no menu do modelo desejado e em <i>Selecionar modelo</i>.</li>
                <li>Entregue as denominação ao Operador. Digite o nome do usuário e a senha em <i>Confirmação Operador</i> após a conferência.</li>
                <li>Digite o nome do usuário e a senha em <i>Autorização Supervisor</i> para continuar o processo de retirada.</li>
                <li>Clique em <i>Confirmar Retirada</i> para liberar os valores.</li>
            </ol>
            </p>
            <h4>Modelos de Retirada / Pacotes</h4>
            <p class="my-4">
            <ol>
                <li>Para utilizar um modelo clique no menu correspondente e selecione <i>Selecionar modelo</i>. As quantidade de denominações serão ajustadas conforme disponibilidade no caixa.</li>
                <li>Para alterar o nome do modelo clique no menu correspondente e selecione <i>Alterar nome do modelo</i>.</li>
                <li>Para excluir um modelo clique no menu correspondente e selecione <i>Excluir</i>.</li>   
            </ol>
            </p>
        </b-modal>
        </div>


    </div>

</template>

<script>
import Vue from 'vue'

import axios from "axios";
import { Callout } from '@coreui/vue'
import ChangeControlUnitComponent from '../../components/ChangeControlUnitComponent'
import ChangeControlHeaderComponent from '../../components/ChangeControlHeaderComponent'
import ChangeControlItemComponent from '../../components/ChangeControlItemComponent'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

 VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)


export default {
    name: 'dashboard',
    components: {
        Callout,
        ChangeControlUnitComponent,
        ChangeControlHeaderComponent,
        ChangeControlItemComponent,
    },
    data: function() {
        return {
            errorMessage: "",
            selectedOperator: { code: null, name: null, supervisor: false},
            selectedSupervisor: { code: null, name: null, supervisor: true},
            selectedTemplate: { id: null, name: "", message: 'Mensagem de teste' },
            templateState: null,

            confirmDelete: '',

            total: 0,
            total_coin: 0,
            total_note: 0,
            
            currentChangeControl: {},

            data_change_outgoing: [
                /*
                { id: 1, operatorCode: 123456, operatorName: 'Alexandre Kenji Takamura', startDate: '2022-06-16 16:27:12', total: 200, class: 'bg-primary' },
                { id: 2, operatorCode: 234567, operatorName: 'José Emílio do Prado', startDate: '2022-06-16 13:41:12', total: 250, class: 'bg-success' },
                */
            ],
            data_change_template: [
                /*
                { id: 1, name: 'Modelo 1', createDate: '2022-06-17 10:01:12', total: 240.00, class: 'bg-pink', denominations: [ { id: 8, quantity: 10 }, { id: 9, quantity: 15 }, { id: 7, quantity: 20} ] },
                { id: 2, name: 'Modelo 2', createDate: '2022-06-17 10:01:12', total: 257.50, class: 'bg-red', denominations: [ { id: 3, quantity: 20 }, { id: 4, quantity: 25 }, { id: 7, quantity: 20}, { id: 8, quantity: 10 }, { id: 9, quantity: 15 } ] },
                */
            ],

            data_denomination: [
                /*
                { id: 0, varname: 'denomination_0', value: 0.01, quantity: 0, totalQuantity: 0, color: 'bg-indigo', image: 'img/currency/real_001.png', imageWidth: 80, type: 1, variant: 'warning' },
                { id: 1, varname: 'denomination_1', value: 0.05, quantity: 200, totalQuantity: 600, color: 'bg-indigo', image: 'img/currency/real_005.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 2, varname: 'denomination_2', value: 0.10, quantity: 250, totalQuantity: 1000, color: 'bg-indigo', image: 'img/currency/real_010.png', imageWidth: 80, type: 1, variant: 'warning'},
                { id: 3, varname: 'denomination_3', value: 0.25, quantity: 100, totalQuantity: 500, color: 'bg-indigo', image: 'img/currency/real_025.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 4, varname: 'denomination_4', value: 0.50, quantity: 100, totalQuantity: 1000, color: 'bg-indigo', image: 'img/currency/real_050.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 5, varname: 'denomination_5', value: 1, quantity: 200, totalQuantity: 300, color: 'bg-indigo', image: 'img/currency/real_1.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 7, varname: 'denomination_7', value: 2, quantity: 50, totalQuantity: 300, color: 'bg-indigo', image: 'img/currency/real_2.png', imageWidth: 130, type: 2, variant: 'success'},
                { id: 8, varname: 'denomination_8', value: 5, quantity: 50, totalQuantity: 300, color: 'bg-indigo', image: 'img/currency/real_5.png', imageWidth: 130, type: 2, variant: 'success' },
                { id: 9, varname: 'denomination_9', value: 10, quantity: 100, totalQuantity: 100, color: 'bg-indigo', image: 'img/currency/real_10.png', imageWidth: 130, type: 2, variant: 'success'  },
                { id: 10, varname: 'denomination_10', value: 20, quantity: 80, totalQuantity: 50, color: 'bg-indigo', image: 'img/currency/real_20.png', imageWidth: 130, type: 2, variant: 'success'  },
                { id: 11, varname: 'denomination_11', value: 50, quantity: 10, totalQuantity: 30, color: 'bg-indigo', image: 'img/currency/real_50.png', imageWidth: 130, type: 2, variant: 'success' },
                { id: 12, varname: 'denomination_12', value: 100, quantity: 0, totalQuantity: 5, color: 'bg-indigo', image: 'img/currency/real_100.png', imageWidth: 130, type: 2, variant: 'success'  },
                */
            ]
        }
    },
    computed: {
        currentUserId() {
            return this.$store.state.currentUser.id;
        },
        currentUnitId() {
            return this.$store.state.currentUnit.id;
        }
    },
    watch: {
        currentUnitId(newId, oldId) {
            //console.log("Unit changed: " + oldId + " - " + newId)
            this.getWaitingReturn()
            this.getTemplate()
            this.getDenominations()
        },
        currentUserId(newId, oldId) {
            //console.log("Operator changed: " + oldId + " - " + newId)
            this.getTemplate() 

            this.selectedSupervisor.name = this.$store.state.currentUser.name;
            this.selectedSupervisor.code = this.$store.state.currentUser.code;
        },
    },
    methods: {
        changeQuantity() {

          var notes = 0;
          var coins = 0;
          this.data_denomination.forEach(function(item) {
            if(item.type == 1)
               coins += item.quantity * item.value
            else
               notes += item.quantity * item.value
          })
          this.total_coin = coins
          this.total_note = notes
          this.total = this.total_coin + this.total_note          
        },
        async checkPassword(userCode, password) {
        
            await axios.get(
                this.$store.state.ws_url + "/sgap/operator?code=" + userCode + "&password=" + password
            ).then(() => {
                return resp;
            }).catch(()=> {
                return 0;
            });
            return resp;
        },
        async getOperator() {
            try {
                if(this.selectedOperator.code) {
                    const operatorResponse = await axios.get(
                        this.$store.state.ws_url + "/sgap/operator?code=" + this.selectedOperator.code
                    );
                    //this.data_denomination = denominationsResponse.data
                    this.selectedOperator = operatorResponse.data
                }
                else {
                    this.selectedOperator = { code: null, name: null, supervisor: true}
                    
                }
            } catch (e) {
                console.log(e)                
            }
        },

        async getSupervisor() {
            try {
                if(this.selectedSupervisor.code) {
                    const supervisorResponse = await axios.get(
                        this.$store.state.ws_url + "/sgap/operator?code=" + this.selectedSupervisor.code
                    );
                    //this.data_denomination = denominationsResponse.data
                    this.selectedSupervisor = supervisorResponse.data                    
                }
                else {
                    this.selectedSupervisor = { code: null, name: null, supervisor: true}
                }
            } catch (e) {
                console.log(e)                
            }
        },

        async saveMovement() {
            try {
                var s = this
                var movement = {}
                var movementDenominations = new Array;

                movement.type = 3   // Fluxo de Retirada
                console.log(this.currentChangeControl)
                movement.changeControlId = this.currentChangeControl.id
                movement.supervisorCode = this.selectedSupervisor.code
                movement.supervisorPwd = this.selectedSupervisor.password

                movement.operatorCode = this.selectedOperator.code
                movement.operatorPwd = this.selectedOperator.password

                
                this.data_denomination.forEach( den => {
                    if(den.quantity > 0) {
                        var denom = { quantity: den.quantity, denomination: { id: den.id }  }
                        movementDenominations.push(denom)
                    }
                })
                movement.denominations = movementDenominations

                console.log(movement)

                //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    
                await axios.post(
                    this.$store.state.ws_url + "/changecontrol/movement",
                    movement
                ).then(function(resp) {

                }).catch(function(error) {
                    console.log(error)
                })                  
                
                this.getWaitingReturn()
                this.showInfoMsg({title: "Nova Retirada", message: "Criado nova retirada" })
                
            } catch (e) {
                console.log(e)                 
                this.showErrorMsg({title: "Nova Retirada", message: "Erro ao criar nova retirada" })
            }  
        },

        async getDenominations() {
            try {
                if(this.$store.state.currentUser.code && this.$store.state.currentUnit.originId) {
                    //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    const denominationsResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/denominations?originId=" + this.$store.state.currentUnit.originId + "&operatorCode=" + this.$store.state.currentUser.code
                    );
                    this.data_denomination = denominationsResponse.data.controlDenominations
                    this.currentChangeControl = denominationsResponse.data

                }
                else {
                     this.data_denomination = []
                }
                this.changeQuantity();
            } catch (e) {
                console.log(e)                 
            }  
        },

        async getWaitingReturn() {
            try {
                if(this.$store.state.currentUnit.originId) {
                    //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    const waitingReturnResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId
                    );
                    this.data_change_outgoing = waitingReturnResponse.data
                    //console.log(waitingReturnResponse.data)
                }
                else {
                     this.data_change_outgoing = []
                }
            } catch (e) {
                console.log(e)                 
            }  
        },

        async getTemplate() {
          
            try {
                if(this.$store.state.currentUser.code && this.$store.state.currentUnit.originId) {
                    var operatorCode = this.$store.state.currentUser.code;
                    //console.log(this.$store.state.ws_url + "/changecontrol/template?operatorCode=" + operatorCode + "&originId=" + this.$store.state.currentUnit.originId)
                    const templateResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/template?operatorCode=" + operatorCode + "&originId=" + this.$store.state.currentUnit.originId
                    );
                    this.data_change_template = templateResponse.data
                    //console.log(templateResponse.data)
                }
                else {
                    //console.log("zerando data_change_template")
                    this.data_change_template = []
                }
            } catch (e) {
                console.log(e)                 
            }
        },
        async changeTemplate() {
            try {
                if(this.selectedTemplate) {
                    const result = await axios.patch(
                        this.$store.state.ws_url + "/changecontrol/template/" + this.selectedTemplate.id,
                        { name: this.selectedTemplate.name }
                    );
                    console.log(result.data.result)
                    if(result.data.result && result.data.result > 0) {
                        this.getTemplate()
                        this.showSuccessMsg({title: "Modelo", message: "Modelo alterado para: " + this.selectedTemplate.name })
                        this.selectedTemplate = { id: null, name: "", message: 'Mensagem de teste' }
                    }
                    else {
                        this.showErrorMsg({title: "Modelo", message: "Erro ao alterar modelo" })
                    }
                    
                }
            } catch (e) {
                console.log(e)                 
            }
        },
        
        async saveTemplate() {
             try {
                if(this.selectedTemplate) {
                    var template = {};
                    var templateDenominations = new Array;

                    template.name = this.selectedTemplate.name
                    template.operatorCode = this.$store.state.currentUser.code
                    template.originId = this.$store.state.currentUnit.originId
                    
                    this.data_denomination.forEach( den => {
                        if(den.quantity > 0) {
                            var denom = { quantity: den.quantity, denomination: { id: den.id }  }
                            templateDenominations.push(denom)
                        }
                    })

                    template.denominations = templateDenominations

                    const result = await axios.post(
                        this.$store.state.ws_url + "/changecontrol/template",
                        template
                    );
                    
                    console.log(result.data.result)
                    
                    if(result.data.result && result.data.result > 0) {
                        this.getTemplate()
                        this.showSuccessMsg({title: "Modelo", message: "Modelo incluído: " + this.selectedTemplate.name })
                        this.selectedTemplate = { id: null, name: "", message: 'Mensagem de teste' }
                    }
                    else {
                        this.showErrorMsg({title: "Modelo", message: "Erro ao incluir modelo" })
                    }
                    
                }
            } catch (e) {
                console.log(e)                 
            }
        },

        templateSave() {
            this.selectedTemplate = { id: null, name: "", message: 'Mensagem de teste' }
            this.errorMessage = ""
            
             if(this.total == null || this.total <= 0) {
                 this.errorMessage = "Nenhuma denominação selecionada."
            }

            if( this.errorMessage.trim() != "") {
                this.showErrorMsg({title: "Salvar Como Modelo", message: this.errorMessage })
            }
            else {
                this.$bvModal.show('modal-template')
            }
        },
        numberFormat(x) {
            return parseFloat(x).toFixed(2).toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        variant(value) {
            let $variant
            if (value <= 25) {
                $variant = 'info'
            } else if (value > 25 && value <= 50) {
                $variant = 'success'
            } else if (value > 50 && value <= 75) {
                $variant = 'warning'
            } else if (value > 75 && value <= 100) {
                $variant = 'danger'
            }
            return $variant
        },
        flag(value) {
            return 'flag-icon flag-icon-' + value
        },
        confirmWithdraw() {
            this.errorMessage = ""
            
            if(this.total == null || this.total <= 0) {
                 this.errorMessage = "Nenhuma denominação selecionada."
            }
            else {
                // Verifica quantidade de denominações
                var den_values = new Array
                this.data_denomination.forEach( den => {
                        if(den.quantity > 0 && den.quantity > den.totalQuantity) {
                            den_values.push( den.value )
                        }
                    })
                if(den_values && den_values.length > 0) {
                    var den_msg = ""
                    var den_sep = ""
                    den_values.forEach( den => {
                        den_msg += den_sep + this.numberFormat(den)
                        den_sep = ", "
                    })
                    this.errorMessage = "Verifique a quantidade disponível das denominações: R$ " + den_msg
                }
            }

            if(this.errorMessage == "") {
                if((this.selectedOperator.name == null || this.selectedOperator.name.trim().length <= 0) && (this.selectedSupervisor.name == null || this.selectedSupervisor.name.trim().length <= 0)) {
                    this.errorMessage = "Necessário confirmação do Operador e autorização do Supervisor."
                }
                else 
                if(this.selectedSupervisor.name == null || this.selectedSupervisor.name.trim().length <= 0) {
                    this.errorMessage = "Necessário autorização do Supervisor."    
                }
                else
                if(this.selectedOperator.name == null || this.selectedOperator.name.trim().length <= 0) {
                    this.errorMessage = "Necessário confirmação do Operador."
                }
                else
                if(this.selectedOperator.name == this.selectedSupervisor.name)
                {
                    this.errorMessage = "Usuário Operador deve ser diferente do usuário Supervisor."
                }
                else
                if(this.selectedOperator.password == null || this.selectedOperator.password.trim().length <= 0 || this.selectedSupervisor.password == null || this.selectedSupervisor.password.trim().length <= 0) {
                    this.errorMessage = "Favor preencher as senhas.";
                }                
            }

            if( this.errorMessage.trim() != "") {
                //this.messageGeneric("Confirmar Saída", this.errorMessage)
                this.showErrorMsg({title: "Confirmar Retirada", message: this.errorMessage })
            }
            else {
                this.saveMovement()

                
            }    
            
        },
        numbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        messageGeneric(label, message) {
            this.$bvModal.msgBoxOk(message, {
            title: label,
            okTitle: 'OK',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                return true
            })
            .catch(err => {
                return false
            })
        },

    // Template - Excluir
        messageConfirmDelete(template) {
            this.confirmDelete = ''
            this.$bvModal.msgBoxConfirm('Deseja realmente excluir o modelo "' + template.name + '"?', {
            title: 'Favor Confirmar',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'SIM',
            cancelTitle: 'NÃO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                this.confirmDelete = value
            })
            .catch(err => {
                // An error occurred
            })
        },

        // Selecionar modelo para alteração das denominações
        templateSelect(template) {
            // Altera a quantidade de denominações
            if(template.denominations!=null) {
                this.data_denomination.forEach( den => {
                    var template_denominations = template.denominations.find( x => x.denomination.id === den.id);
                    if(template_denominations != null) {
                        den.quantity = template_denominations.quantity
                    }
                    else {
                        den.quantity = 0
                    }
                })
                this.changeQuantity()
            }
            else {
                this.messageGeneric("Modelo", "Sem denominação.")
            }
        },

        templateCheckValidity() {
            //const valid = this.$refs.form.checkValidity()
            let valid = this.selectedTemplate.name.trim().length > 3
            if(valid) {
                this.data_change_template.forEach( template => { console.log(template.name); if( template.name == this.selectedTemplate.name && template.id != this.selectedTemplate.name ) valid = false; return; } )

                if(!valid) this.selectedTemplate.message = 'Nome de modelo já cadastrado. Verifique e tente novamente.'
            }
            else {
                this.selectedTemplate.message = 'Nome do modelo obrigatório com no mínimo 3 caracteres.'
            }
            this.templateState = valid
            return valid
        },
        templateReset() {
            //this.selectedTemplate.name = ''
            this.templateState = null
        },
        templateHandleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.templateHandleSubmit()
        },
        templateHandleSubmit() {
            // Exit when the form isn't valid
            if (!this.templateCheckValidity()) {
            return
            }
            
            // Push the name to submitted names
            if(this.selectedTemplate.id)
                this.changeTemplate()
            else
                this.saveTemplate()
            
            // Hide the modal manually
            this.$nextTick(() => {
            this.$bvModal.hide('modal-template')
            })
        },

    },
    mounted: function(){
        this.changeQuantity()
        this.getWaitingReturn()
        this.getTemplate()
        this.getDenominations()

        this.selectedSupervisor.name = this.$store.state.currentUser.name;
        this.selectedSupervisor.code = this.$store.state.currentUser.code;
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Hello there',
        message: 'That\'s the success!'
        },
        showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Hey you',
        message: 'Here is some info for you'
        },
        showWarnMsg: {
        type: VueNotifications.types.warn,
        title: 'Wow, man',
        message: 'That\'s the kind of warning'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Erro',
        message: ""
        }
    }
}
</script>


<style>
</style>
